module.exports = __webpack_public_path__ + "img/logo_footer2.f7126267.svg";